import dynaForms from '@elab/core/utils/dynaForms';

const getSelectors = storeName => {
    const dynaSelectors = dynaForms.getSelectors(storeName);

    const getForm = state => (state && dynaSelectors.getStore(state)) || {};
    const getAuthOption = state => getForm(state).authOption || null;
    const getCustomerLoyaltyStatus = state => getForm(state).customerLoyaltyStatus || null;

    return {
        ...dynaSelectors,
        getAuthOption,
        getCustomerLoyaltyStatus,
    };
};

export default getSelectors;
